export const generateSurveyResponse = (surveyPageData) => {
  let surveyResponseObj = {"surveyPageId": surveyPageData.id,
                           "surveyPagePosition": surveyPageData.position,
                           "questionResponses": []};
  surveyResponseObj.questionResponses = surveyPageData.questions.map((question) => {
    return {
      "question_id": question.id,
      "answer_id": null,
      "response": "",
      "star_rating": null,
      "required": question.required,
      "answer_ids": []
    }
  })
  return surveyResponseObj;
}


export const isQuestionResponseValid = (questionResponse) => {
  let isValid = true;
  if(questionResponse.required) {
    isValid = questionResponse.star_rating != null || questionResponse.answer_id != null || (questionResponse.answer_ids && questionResponse.answer_ids.length) || questionResponse.response != "";
  }
  return isValid;
}


export const checkIfQuestionsAreValid = (questionResponses) => {
  let isValid = true;
  for (var i = 0; i < questionResponses.length; i++) {
    if(!isQuestionResponseValid(questionResponses[i])) {
      isValid = false;
      break;
    }
  }
  return isValid;
}

export const generateJsonFromSurveyResponses = (surveyResponses, accountId) => {
  let questionResponses = [];
  for (var i = 0; i < surveyResponses.length; i++) {
    questionResponses.push.apply(questionResponses, surveyResponses[i].questionResponses);
  }
  let data = {
    "survey_response": {
      "question_responses_attributes" : questionResponses
    }
  }
  if(accountId != null) {
    data["survey_response"]["account_id"] = accountId;
  }
  return JSON.stringify(data);
}

export const getLoadingTextFromLoadingType = (loadingType) => {
  switch (loadingType) {
    case "loading_survey":
      return "Loading survey content..."
    case "submitting_survey":
      return "Submitting Survey..."
    case "error":
      return "Unfortunately we were unable to load the content."
    case "submitted":
      return "Thank you. Your survey has been submitted."
    default:
      return "Loading..."
  }
}
